// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MultiImageUploader_wrapper__3H-WU"};